import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-file-ppt-fill",
  "use": "rt-base-file-ppt-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-file-ppt-fill\"><defs><style type=\"text/css\"></style></defs><path d=\"M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.5 760v-91.5h59.3c60.6 0 100.2-39.7 100.2-98.1 0-58.2-39.6-98.3-100-98.3H424c-6.6 0-12 5.4-12 12v276c0 6.6 5.4 12 12 12h32.5c6.7-0.1 12-5.5 12-12.1z m0-139.3h34.9c47.8 0 67.2-12.9 67.2-50.3 0-32-18.1-50.1-49.9-50.1h-52.2v100.4z\" p-id=\"2691\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/file-ppt-fill.svg
// module id = 1267
// module chunks = 72